import { useIsMutating } from '@tanstack/react-query';

export const useGlobalDeleteState = () => {
  const deleteAssetPending = useIsMutating({
    mutationKey: ['deleteAsset'],
  });
  const deleteFolderPending = useIsMutating({
    mutationKey: ['deleteFolder'],
  });

  const isAnyDeletePending = deleteAssetPending > 0 || deleteFolderPending > 0;

  return {
    isAnyDeletePending,
  };
};
